import React from 'react'
import styled from 'styled-components'
import {ThemeColor} from 'themes'
import {Icon} from '../../icons/Icon'
import {Paragraph} from '../../texts/Paragraph'
import {Pressable} from '../../pressables/Pressable'
import {MenuItemProps} from './MenuItemProps'

interface StyledContainerProps {
  color?: ThemeColor
}

const StyledContainer = styled.div<StyledContainerProps>`
  ${({theme, color = 'black'}) => ({color: theme[color]})}
  display: flex;
  flex-direction: row;
  width: '100%';
  padding: 12px 24px;
  color: ${({theme, color = 'black'}) => theme[color]};
  gap: 12px;
  transition: background-color linear 0.125s;

  :hover {
    background-color: ${({theme}) => theme.white_4};
  }
`

export default function MenuItem({
  title,
  icon,
  color,
  fontWeight = 'medium',
  onClick,
}: MenuItemProps) {
  return (
    <Pressable onClick={onClick}>
      <StyledContainer color={color}>
        {icon ? <Icon type={icon} color="inherit" /> : null}
        <Paragraph fontSize="m" color="inherit" fontWeight={fontWeight}>
          {title}
        </Paragraph>
      </StyledContainer>
    </Pressable>
  )
}
